import { Graphics } from "pixi.js";
export const draggingOutline = new Graphics({
    eventMode: "none",
    zIndex: 10001,
    hitArea: null,
    label: "DRAGGING_OUTLINE",
});
//# sourceMappingURL=draggingOutline.js.map